import type { MRT_RowData, MRT_TableOptions } from 'material-react-table';

// A factory, not a shared constant: MRT mutates the initialState object it's given on mount
// (it writes columnOrder into it), which would leak the first table's column order into all others.
export const getDefaultTableOptions = () =>
  ({
    layoutMode: 'grid',
    initialState: { density: 'compact' },
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableColumnFilterModes: false,
    enableColumnPinning: false,
    enablePagination: false,
    enableRowSelection: false,
    enableFilters: false,
    enableRowVirtualization: false,
    enableCellActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
  }) satisfies Partial<MRT_TableOptions<MRT_RowData>>;

export const serverSideTableOptions = {
  enablePagination: true,
  manualPagination: true,
  manualSorting: true,
} satisfies Partial<MRT_TableOptions<MRT_RowData>>;
